// @flow

import { apiClients } from '@app/services/api/clients'
import { getApiClient } from '@app/utils/apiUtils'

/**
 * API to reveal the full address for a given order
 * @param {string} country - The country code
 * @param {string} orderId - The order/tracking ID
 * @returns {Promise<any>} - Response containing address details
 */
export const revealAddressApi = (country: string, orderId: string): Promise<any> => {
  const client = getApiClient(apiClients, country)
  const url = `2.0/orders/${orderId}/to-address`
  return client.get(url)
}
